import { render, staticRenderFns } from "./DropdownSettingsIndex.vue?vue&type=template&id=f250ed0a&"
import script from "./DropdownSettingsIndex.vue?vue&type=script&lang=js&"
export * from "./DropdownSettingsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports